import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/shape1.png'
import _imports_1 from '../../assets/img/shape2.svg'
import _imports_2 from '../../assets/img/shape3.svg'
import _imports_3 from '../../assets/img/shape4.svg'
import _imports_4 from '../../assets/img/shape5.png'


const _hoisted_1 = { class: "pricing-area bg-f9f6f6" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "pricing-table" }
const _hoisted_5 = { class: "pricing-header" }
const _hoisted_6 = { class: "price" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "pricing-footer d-flex justify-content-between p-2" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "modal-header" }
const _hoisted_14 = { class: "modal-title" }
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_23 = { class: "modal-content" }
const _hoisted_24 = { class: "modal-header" }
const _hoisted_25 = { class: "modal-title" }
const _hoisted_26 = { class: "modal-body" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = { class: "modal-footer" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "modal-backdrop fade show"
}

import { computed, ref } from 'vue'
import { formationStore } from '../../store/formations'
import { FormationType } from '../../types/formation'
import type { Timestamp } from 'firebase/firestore'
import { UserType } from '../../types/user'

import { useToast } from 'vue-toastification'
import { useHead } from '@vueuse/head'

export default /*@__PURE__*/_defineComponent({
  __name: 'EnrolFormation',
  setup(__props) {

useHead({
  title: 'Inscription - IT+ CODE LAB',
  meta: [
    { name: 'description', content: 'Inscrivez-vous à nos formations et cours disponibles. | Code Lab | Cours et Formations en informatique à Djibouti' },
    { name: 'keywords', content: 'formation,Code Lab,formations,angular,vue, html, css,linux,sécurité,javascript, java, informatique,djibouti, Djibouti, programmation, réseaux, cours, codelab, it+' }
  ]
})
const toast = useToast()
const store = formationStore()
const showModal = ref(false)
const showModalInterestd = ref(false)
const selectedFormation = ref(new FormationType())
const newStudent = ref(new UserType())
const allFormations = computed(() => {
  return store.getAllformationsDispo()
})
// const progress = (formation: FormationType) => { return ((formation.students.length / formation.maxStudents) * 100) };

// const formatDate = (date: Date | Timestamp) => {

//     return new Date(date.toString()).toLocaleDateString()

// }

const register = async (formation: FormationType) => {
  selectedFormation.value.students.push(newStudent.value)
  await store.updateFormation(formation)
  toast.success('Enregistrement effectué avec succés')
  showModal.value = false
  const phoneNumber = '25377151875' // Replace with recipient's number (no "+" or spaces)
  const message = encodeURIComponent('Hello! I need some help.')
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`

  window.open(whatsappLink, '_blank')
}
const imInterested = async (formation: FormationType) => {
  if (selectedFormation.value.interestedStudents) {
    selectedFormation.value.interestedStudents.push(newStudent.value)
  } else {
    selectedFormation.value.interestedStudents = [newStudent.value]
  }
  await store.updateFormation(formation)
  toast.success('Enregistrement effectué avec succés')
  showModalInterestd.value = false
}
const openModal = (formation: FormationType, isModal: boolean) => {
  selectedFormation.value = formation
  if (isModal) {
    showModal.value = true
  } else {
    showModalInterestd.value = true
  }
}

const isEmailDisabled = computed(() => {
  if (selectedFormation.value.students?.find(student => student.email === newStudent.value.email)) {
    return true
  } else return false
})
const isEmailDisabled2 = computed(() => {
  if (selectedFormation.value.interestedStudents?.find(student => student.email === newStudent.value.email)) {
    return true
  } else return false
})
const isDisabled = computed(() => {
  if (newStudent.value.name === '' || newStudent.value.mobile === 0 || newStudent.value.email === '') {
    return true
  } else return false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"page-title-area\"><div class=\"d-table\"><div class=\"d-table-cell\"><div class=\"container\"><h2>Inscrivez-vous à nos formations disponibles</h2><div class=\"bar\"></div></div></div></div><div class=\"shape1\"><img src=\"" + _imports_0 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape3\"><img src=\"" + _imports_2 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape5\"><img src=\"" + _imports_4 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape6 rotateme\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div></div>", 1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allFormations.value, (formation, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-lg-4 col-md-6 col-sm-6 m-auto",
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", null, _toDisplayString(formation?.courseName), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(formation?.price), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("sup", null, "Fdj", -1)),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    _cache[12] || (_cache[12] = _createElementVNode("span", null, "/Mois", -1))
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", null, "Pendant " + _toDisplayString(formation?.numberOfMonth) + " mois ", 1)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "price" }, null, -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", null, _toDisplayString(formation.description), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-success",
                    onClick: ($event: any) => (openModal(formation, true))
                  }, "Je m'inscris! 💪👩‍🎓", 8, _hoisted_9),
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-primary",
                    onClick: ($event: any) => (openModal(formation, false))
                  }, "Je suis interessé! 👀", 8, _hoisted_10)
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass(["modal fade", { show: showModal.value }]),
            style: _normalizeStyle({ display: showModal.value ? 'block' : 'none' })
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h5", _hoisted_14, "Vous vous enregistré à cette formation: " + _toDisplayString(selectedFormation.value.courseName), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false))
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", {
                      for: "",
                      class: "form-label"
                    }, "Mon nom", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "",
                      id: "",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newStudent.value.name) = $event))
                    }, null, 512), [
                      [_vModelText, newStudent.value.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                      for: "",
                      class: "form-label"
                    }, "Mon email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      name: "",
                      id: "",
                      "aria-describedby": "emailHelpId",
                      placeholder: "abc@mail.com",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newStudent.value.email) = $event))
                    }, null, 512), [
                      [_vModelText, newStudent.value.email]
                    ]),
                    (isEmailDisabled.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, _cache[16] || (_cache[16] = [
                          _createElementVNode("em", null, "Cet email est deja utilisé pour ce cours", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", {
                      for: "",
                      class: "form-label"
                    }, "Mon numéro", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      name: "",
                      id: "",
                      placeholder: "77",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newStudent.value.mobile) = $event))
                    }, null, 512), [
                      [_vModelText, newStudent.value.mobile]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (register(selectedFormation.value))),
                    disabled: isDisabled.value
                  }, "Je m'enregistre", 8, _hoisted_21)
                ])
              ])
            ])
          ], 6),
          _createElementVNode("div", {
            class: _normalizeClass(["modal fade", { show: showModalInterestd.value }]),
            style: _normalizeStyle({ display: showModalInterestd.value ? 'block' : 'none' })
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h5", _hoisted_25, "Vous êtes interessé par cette: " + _toDisplayString(selectedFormation.value.courseName), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (showModalInterestd.value = false))
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[23] || (_cache[23] = _createElementVNode("p", null, "Indiquez vos coordonnés vous serez contacté! 😌😄", -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                      for: "",
                      class: "form-label"
                    }, "Mon nom", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      name: "",
                      id: "",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newStudent.value.name) = $event))
                    }, null, 512), [
                      [_vModelText, newStudent.value.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", {
                      for: "",
                      class: "form-label"
                    }, "Mon email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      name: "",
                      id: "",
                      "aria-describedby": "emailHelpId",
                      placeholder: "abc@mail.com",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newStudent.value.email) = $event))
                    }, null, 512), [
                      [_vModelText, newStudent.value.email]
                    ]),
                    (isEmailDisabled2.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _cache[20] || (_cache[20] = [
                          _createElementVNode("em", null, "Cet email est deja utilisé pour ce cours", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", {
                      for: "",
                      class: "form-label"
                    }, "Mon numéro", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      name: "",
                      id: "",
                      placeholder: "77",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newStudent.value.mobile) = $event))
                    }, null, 512), [
                      [_vModelText, newStudent.value.mobile]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (imInterested(selectedFormation.value))),
                    disabled: isDisabled.value
                  }, "Me contacter", 8, _hoisted_32)
                ])
              ])
            ])
          ], 6),
          (showModal.value || showModalInterestd.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div>", 4))
    ])
  ]))
}
}

})